import { Component, HostListener, Input } from "@angular/core";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";
import { EdpModalService } from "@edp-components/edp-modal";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserService } from "@edp-services/user.service";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { ShowLoader } from "@edp-store/actions/layout.actions";
import { EdpToasterService } from "@edp-components/edp-toaster/edp-toaster.service";
import { TranslateService } from "@ngx-translate/core";
import { EdpToastType } from "@edp-components/edp-toaster/edp-toast-type";
import { SetTermsCond } from "@edp-store/actions/user.actions";
import { SCREEN_SIZES } from "@edp-enums/screen-sizes.enum";

const parentClassModal = "modal-dialog";
const classSmall = "modal-sm";
const classLarge = "modal-lg";

@Component({
    selector: "edp-terms-conditions-modal",
    templateUrl: "./edp-terms-conditions-modal.component.html",
    styleUrls: ["./edp-terms-conditions-modal.component.scss"],
})
export class EdpTermsConditionsModalComponent {
    @Input() public data: IModalData;
    public form: FormGroup;
    public showTerms: boolean;
    public mobileSize: boolean;
    public mailTo: string;

    @HostListener("window:resize")
    public onResize() {
        this.mobileSize = false;
        if (window.innerWidth < SCREEN_SIZES.WDGT) {
            this.mobileSize = true;
        }
    }

    constructor(
        private readonly fb: FormBuilder,
        private edpModalService: EdpModalService,
        private userService: UserService,
        private readonly store: Store<IAppState>,
        private readonly edpToasterService: EdpToasterService,
        private readonly translateService: TranslateService
    ) {
        this.onResize();
        this.form = this.fb.group({
            acceptTerms: [false, Validators.requiredTrue],
        });
        this.mailTo = this.translateService.instant("pt.edponline.terms.modal.description.label.email");
    }

    private changeSize(): void {
        if (this.mobileSize) {
            return;
        }
        try {
            const classToRemove = this.showTerms ? classSmall : classLarge;
            const classToAdd = this.showTerms ? classLarge : classSmall;
            document
                .getElementsByClassName(parentClassModal)
                .item(0)
                .classList.replace(classToRemove, classToAdd);
        } catch (error) {} 
    }

    public openTerms(): void {
        this.showTerms = true;
        this.changeSize();
    }

    public closeTerms(): void {
        this.showTerms = false;
        this.changeSize();
    }

    private showError(): void {
        const label = this.translateService.instant("pt.edp.edponline.contract.contact.info.phone.modal.generic.error");
        this.edpToasterService.create(label, EdpToastType.error, { timeout: 3000 }).show();
    }

    public submit(): void {
        if (!!this.form.invalid) {
            return;
        }
        this.store.dispatch(new ShowLoader(true));
        this.userService.acceptTerm().subscribe(
            () => {
                this.store.dispatch(new SetTermsCond());
                this.closeModal();
            },
            error => this.showError(),
            () => this.store.dispatch(new ShowLoader(false))
        );
    }

    public closeModal(): void {
        this.edpModalService.close(false);
    }
}
